import { Dialog, Text } from "@chakra-ui/react";
import type React from "react";
import { Button } from "./ui/button";

interface GeneralModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string | React.ReactNode;
  mainAction: () => void;
  mainActionLabel: string;
  secondAction?: () => void;
  secondActionLabel?: string;
  showCancelButton?: boolean;
  loading?: boolean;
  bodyColor?: string;
}

export const GeneralModal: React.FC<GeneralModalProps> = ({
  open,
  onClose,
  title,
  body,
  mainAction,
  mainActionLabel,
  secondAction,
  secondActionLabel,
  showCancelButton = true,
  loading = false,
  bodyColor,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={(e) => (e.open ? undefined : onClose())}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>
            <Dialog.Title>{title}</Dialog.Title>
          </Dialog.Header>
          <Dialog.Body whiteSpace="pre-wrap" textAlign="left">
            {typeof body === "string" ? <Text color={bodyColor}>{body}</Text> : body}
          </Dialog.Body>
          <Dialog.Footer>
            <Button colorPalette="yellow" mr={3} onClick={mainAction} loading={loading}>
              {mainActionLabel}
            </Button>
            {secondAction && (
              <Button variant="ghost" mr={3} onClick={secondAction} loading={loading}>
                {secondActionLabel}
              </Button>
            )}
            {showCancelButton && (
              <Button variant="ghost" onClick={onClose} loading={loading}>
                キャンセル
              </Button>
            )}
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
